// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AutomationFunction
 */
export interface AutomationFunction {
    /**
     * Browse Path to a LADSControlFunction which shall be executed or modified with a targetValue
     */
    path: string;
    /**
     * TargetValue to set when automation is started. If null, the LADS start() function will be called
     */
    targetValueStart: string | null;
    /**
     * TargetValue to set when automation is stopped. If null, the LADS stop() function will be called
     */
    targetValueEnd: string | null;
}

/**
 * Check if a given object implements the AutomationFunction interface.
 */
export function instanceOfAutomationFunction(value: object): value is AutomationFunction {
    if (!('path' in value) || value['path'] === undefined) return false;
    if (!('targetValueStart' in value) || value['targetValueStart'] === undefined) return false;
    if (!('targetValueEnd' in value) || value['targetValueEnd'] === undefined) return false;
    return true;
}

export function AutomationFunctionFromJSON(json: any): AutomationFunction {
    return AutomationFunctionFromJSONTyped(json, false);
}

export function AutomationFunctionFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutomationFunction {
    if (json == null) {
        return json;
    }
    return {
        
        'path': json['path'],
        'targetValueStart': json['targetValueStart'],
        'targetValueEnd': json['targetValueEnd'],
    };
}

export function AutomationFunctionToJSON(json: any): AutomationFunction {
    return AutomationFunctionToJSONTyped(json, false);
}

export function AutomationFunctionToJSONTyped(value?: AutomationFunction | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'path': value['path'],
        'targetValueStart': value['targetValueStart'],
        'targetValueEnd': value['targetValueEnd'],
    };
}

